import { CircularProgressWithLabel } from '@app/components/base/CircularProgressWithLabel';
import { Box, CircularProgress, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

interface MediaInProgressLoaderProps {
  /** Export progress percent (1–99) from the fragment media asset, when available. */
  progressPercent?: number;
}

/** Spinner with in-ring progress (when available) and status message for in-progress fragment media. */
export function MediaInProgressLoader({ progressPercent }: MediaInProgressLoaderProps) {
  const hasProgress = typeof progressPercent === 'number' && progressPercent > 0;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      {hasProgress ? (
        <CircularProgressWithLabel value={progressPercent} size={32} indeterminate />
      ) : (
        <CircularProgress size={16} />
      )}
      <Typography variant="body2" color="text.secondary">
        <FormattedMessage
          id="fragments.mediaStatus.waiting"
          defaultMessage="Generación de media en proceso"
        />
      </Typography>
    </Box>
  );
}
